export class EnumUtils {
    static getByValue = (myEnum, enumValue) => {
        return myEnum[Object.keys(myEnum)[Object.values(myEnum).indexOf(enumValue)]];
    };
}
